import { render } from "./DefaultProjectCard.vue?vue&type=template&id=b5e48462"
import script from "./DefaultProjectCard.vue?vue&type=script&lang=js"
export * from "./DefaultProjectCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/minty.crm.frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__